import Swiper from "swiper";
import { Navigation, Pagination, A11y } from "swiper/modules";

class ServiceModal {
  constructor() {
    this.modal = document.getElementById("service-modal");
    this.wrapper = this.modal?.querySelector(".swiper-wrapper");
    this.titleEl = this.modal?.querySelector(".service-modal__title");
    this.descEl = this.modal?.querySelector(".service-modal__desc");
    this.swiper = null;
    this.bind();
  }

  bind() {
    const grids = document.querySelectorAll(".js-services-grid");
    if (!grids.length || !this.modal) return;

    grids.forEach(grid => {
      grid.addEventListener("click", (e) => {
        const card = e.target.closest(".services__card, .services-card");
        if (!card) return;
        this.openFromCard(card);
      });
      grid.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          const card = e.target.closest(".services__card, .services-card");
          if (card) { e.preventDefault(); this.openFromCard(card); }
        }
      });
    });

    this.modal.addEventListener("click", (e) => {
      if (e.target.closest(".js-service-close")) this.close();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.close();
    });
  }

  openFromCard(card) {
    const title = (card.querySelector(".services__card-title, .services-card__title")?.textContent || "").trim();
    const desc  = (card.getAttribute('data-desc') || "").trim();
    const images = (card.getAttribute("data-gallery") || "").split(",").map(s => s.trim()).filter(Boolean);

    this.titleEl.textContent = title;
    this.descEl.textContent  = desc;

    this.wrapper.innerHTML = images.map(src =>
      `<div class="swiper-slide"><img src="${src}" alt="${title}"/></div>`
    ).join("");

    this.open(() => this.mountSwiper(images.length));
  }

  open(afterShow) {
    this.modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
    requestAnimationFrame(() => {
      this.modal.getBoundingClientRect();
      requestAnimationFrame(() => { if (typeof afterShow === "function") afterShow(); });
    });
  }

  mountSwiper(count) {
    if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; }
    Swiper.use([Navigation, Pagination, A11y]);
    const el = this.modal.querySelector(".service-modal__swiper");

    this.swiper = new Swiper(el, {
      init: false,
      slidesPerView: 1,
      spaceBetween: 12,
      loop: count > 1,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      resizeObserver: true,
      navigation: {
        nextEl: this.modal.querySelector(".service-modal__next"),
        prevEl: this.modal.querySelector(".service-modal__prev")
      },
      pagination: {
        el: this.modal.querySelector(".service-modal__pagination"),
        clickable: true
      }
    });

    el.style.width = "100%";
    el.getBoundingClientRect();
    this.swiper.init();
    this.swiper.updateSize();
    this.swiper.updateSlides();
    this.swiper.updateProgress();
    this.swiper.updateSlidesClasses();

    this.modal.querySelectorAll(".swiper-slide img").forEach(img => {
      img.addEventListener("load", () => this.swiper && this.swiper.update());
    });
  }

  close() {
    this.modal.classList.remove("is-open");
    document.body.style.overflow = "";
    if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; }
    this.wrapper.innerHTML = "";
  }
}

export default ServiceModal;
